import React from 'react';
import './Bienvenidos.css';

const Bienvenidos = () => {

    return (
        <div className='fondo-bienvenidos' /> 
    );
};

export default Bienvenidos;
